/* US age self-declaration. No DOB, ID document or marketing data collected. */
(() => {
  'use strict';
  const VERSION = 'us-21-self-declaration-v1';
  const KEY = 'lr-age318';
  const TTL = 60 * 24 * 60 * 60 * 1000;
  const root = window.Shopify?.routes?.root || '/';
  const gate = document.querySelector('[data-lr-age318]');
  if (!gate) return;
  let confirmed = false, saving = false, touched = false;
  const valid = value => value?.version === VERSION && value?.age === 21 && Number.isFinite(value.at) && value.at <= Date.now() && Date.now() - value.at < TTL;
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch (_) { return null; } };
  const remember = () => { try { localStorage.setItem(KEY, JSON.stringify({version:VERSION, age:21, at:Date.now()})); } catch (_) {} };
  const update = async attributes => {
    const response = await fetch(root + 'cart/update.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes})});
    if (!response.ok) throw new Error((window.lrT&&window.lrT["we_couldnt_save_your_confirmation_06e1"]||'We couldn’t save your confirmation. Please try again.'));
    return response.json();
  };
  const reflect = () => {
    document.querySelectorAll('[data-lr-age-confirm318]').forEach(input => { input.checked = confirmed; input.disabled = saving; });
    document.querySelectorAll('[data-lr-age-status318]').forEach(note => { note.textContent = saving ? (window.lrT&&window.lrT["saving_confirmation_557a"]||'Saving confirmation…') : confirmed ? (window.lrT&&window.lrT["21_confirmed_saved_with_your_order_6c48"]||'21+ confirmed. Saved with your order.') : (window.lrT&&window.lrT["required_before_checkout_bd1d"]||'Required before checkout. Confirmation is saved with your order.'); });
    document.querySelectorAll('[data-lr-age-express318]').forEach(block => { block.hidden = !confirmed; });
  };
  const show = () => { if (!gate.open) gate.showModal(); };
  gate.addEventListener('cancel', event => event.preventDefault());
  gate.querySelector('[data-lr-age-no318]').addEventListener('click', () => {
    const error = gate.querySelector('[data-lr-age-error318]');
    error.textContent = (window.lrT&&window.lrT["you_must_be_21_or_older_to_enter_c546"]||'You must be 21 or older to enter this website.'); error.hidden = false;
  });
  gate.querySelector('[data-lr-age-yes318]').addEventListener('click', async event => {
    const button = event.currentTarget, error = gate.querySelector('[data-lr-age-error318]');
    button.disabled = true; error.hidden = true;
    try {
      await update({'Age declaration — arrival':'I confirm I am 21 or older', 'Age declaration — arrival UTC':new Date().toISOString(), 'Age declaration — version':VERSION});
      remember(); gate.close();
    } catch (failure) { error.textContent = failure.message; error.hidden = false; }
    finally { button.disabled = false; }
  });
  document.addEventListener('change', async event => {
    if (!event.target.matches('[data-lr-age-confirm318]')) return;
    const requested = event.target.checked;
    touched = true;
    saving = true; confirmed = false; reflect();
    try {
      await update({'Age declaration — checkout':requested ? 'I confirm I am 21 or older' : '', 'Age declaration — checkout UTC':requested ? new Date().toISOString() : '', 'Age declaration — version':VERSION});
      confirmed = requested;
    } catch (failure) {
      saving = false; confirmed = false; reflect();
      document.querySelectorAll('[data-lr-age-cart318]').forEach(box => {
        box.classList.add('is-error');
        box.querySelector('[data-lr-age-status318]').textContent = (window.lrT&&window.lrT["we_couldnt_save_your_confirmation_06e1"]||'We couldn’t save your confirmation. Please try again.');
      });
      return;
    }
    saving = false; document.querySelectorAll('[data-lr-age-cart318]').forEach(box => box.classList.remove('is-error')); reflect();
  });
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout' || (confirmed && !saving)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const box = event.target.querySelector('[data-lr-age-cart318]');
    if (box) { box.classList.add('is-error'); box.querySelector('[data-lr-age-status318]').textContent = saving ? (window.lrT&&window.lrT["please_wait_while_your_ef46"]||'Please wait while your confirmation is saved.') : (window.lrT&&window.lrT["please_confirm_you_are_21_or_older_6120"]||'Please confirm you are 21 or older to continue.'); box.querySelector('input').focus(); }
  }, true);
  document.addEventListener('lr:cart-refreshed', reflect);
  // Drawer HTML is replaced when items change; keep the confirmation in sync.
  new MutationObserver(records => { if (records.some(record => record.addedNodes.length && [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-lr-cart-drawer]') || node.querySelector?.('[data-lr-age-cart318]'))))) reflect(); }).observe(document.body, {childList:true, subtree:true});
  fetch(root+'cart.js', {credentials:'same-origin'}).then(response => response.ok ? response.json() : null).then(cart => {
    const attrs = cart?.attributes || {}, at = Date.parse(attrs['Age declaration — checkout UTC']);
    if (touched) return;
    confirmed = attrs['Age declaration — checkout'] === 'I confirm I am 21 or older' && valid({version:attrs['Age declaration — version'],age:21,at}); reflect();
  }).catch(() => reflect());
  reflect();
  if (!valid(read()) && !location.pathname.startsWith('/policies/')) show();
})();
